import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import Banner from "../../components/Banner/Banner";
import TradedStocks from "../../components/TradedStocks/TradedStocks";
import StockPrices from "../../components/StockPrices/StockPrices";
import RelatedVideos from "../../components/RelatedVideos/RelatedVideos";
import DadachainIntro from "../../components/DadachainIntro/DadachainIntro";
import MarketSketch from "../../components/MarketSketch/MarketSketch";
import Library from "../../components/Library/Library";
import AffiliatedPartners from "../../components/AffiliatedPartners/AffiliatedPartners";
import cseBanner from "../../assets/images/cse.png";
import cseLogo from "../../assets/images/cse2.png";
import styles from "./Home.module.css";

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ESC 키를 누르면 모달 닫힘
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsModalOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // 각 섹션에 대한 참조 생성
  const tradedStocksRef = useRef(null);
  const stockPricesRef = useRef(null);
  const relatedVideosRef = useRef(null);
  const dadachainRef = useRef(null);
  const marketSketchRef = useRef(null);
  const libraryRef = useRef(null);
  const partnersRef = useRef(null);

  return (
    <div className={styles.homeContainer}>
      {/* Header에 scrollToSection 속성 전달 */}
      <Header
        scrollToSection={{
          tradedStocks: tradedStocksRef,
          stockPrices: stockPricesRef,
          relatedVideos: relatedVideosRef,
          dadachain: dadachainRef,
          marketSketch: marketSketchRef,
          library: libraryRef,
          partners: partnersRef,
        }}
      />
      <Banner />
      <div
        className={styles.cseBannerContainer}
        onClick={() => setIsModalOpen(true)}
      >
        <img src={cseBanner} alt="CSE Banner" className={styles.cseBanner} />
      </div>
      <section ref={tradedStocksRef} className={styles.section}>
        <TradedStocks />
      </section>

      <section ref={stockPricesRef} className={styles.section}>
        <StockPrices />
      </section>

      <section ref={relatedVideosRef} className={styles.section}>
        <RelatedVideos />
      </section>

      <section ref={dadachainRef} className={styles.section}>
        <DadachainIntro />
      </section>

      <section ref={marketSketchRef} className={styles.section}>
        <MarketSketch />
      </section>

      <section ref={libraryRef} className={styles.section}>
        <Library />
      </section>

      <section ref={partnersRef} className={styles.section}>
        <AffiliatedPartners />
      </section>
      {/* 모달 창 */}
      {isModalOpen && (
        <div
          className={styles.modalOverlay}
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.closeBtn}
              onClick={() => setIsModalOpen(false)}
            >
              X
            </button>
            <img src={cseLogo} alt="cseLogo" />
            <p>
              The Canadian Securities Exchange (CSE), established in 2003, is
              one of Canada's prominent stock exchanges, providing efficient
              capital-raising opportunities for emerging and venture companies.
              Alongside the Toronto Stock Exchange (TSX) and TSX Venture
              Exchange, the CSE has established itself as a key Canadian
              exchange with relatively lower listing requirements and
              maintenance costs, making it an attractive platform for
              growth-stage companies. The exchange has gained prominence with
              numerous listings in emerging sectors including technology, life
              sciences, mining, and cannabis industries, and attracts
              significant interest from global companies seeking to enter the
              North American market.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
